import { useEffect, useRef } from "react";

/**
 * Adds .in-view to elements with .reveal when they scroll into the viewport.
 * One-shot — once revealed, stays revealed.
 */
export function useReveal() {
    const rootRef = useRef(null);

    useEffect(() => {
        const root = rootRef.current || document;
        const targets = root.querySelectorAll(".reveal");
        if (!("IntersectionObserver" in window) || targets.length === 0) {
            targets.forEach((el) => el.classList.add("in-view"));
            return;
        }
        const io = new IntersectionObserver(
            (entries) => {
                entries.forEach((e) => {
                    if (e.isIntersecting) {
                        e.target.classList.add("in-view");
                        io.unobserve(e.target);
                    }
                });
            },
            { threshold: 0.12 }
        );
        targets.forEach((el) => io.observe(el));
        return () => io.disconnect();
    }, []);

    return rootRef;
}
